import React from 'react';
import { motion } from 'framer-motion';
import { Lightning } from '@phosphor-icons/react';

export default function HeavyOrchestraPanel({ phase }) {
  if (!phase) return null;
  const { stage, total, label, shards } = phase;
  const activeStart = stage * 12;
  const activeEnd = activeStart + 12;

  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
      className="glass-panel rounded-xl px-4 py-3 mb-4 ml-9" data-testid="heavy-orchestra-panel">
      <div className="flex items-center justify-between mb-2.5">
        <span className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest heavy-gradient-text">
          <Lightning weight="fill" className="w-3.5 h-3.5 text-lime-400" /> Lindey Heavy
        </span>
        <span className="text-[10px] font-mono text-white/40" data-testid="heavy-phase-label">
          {label} · cluster {Math.min(stage + 1, total)}/{total} · {shards} shards
        </span>
      </div>
      <div className="grid grid-cols-12 gap-1">
        {Array.from({ length: shards }).map((_, i) => {
          const state = i < activeStart ? 'done' : i < activeEnd ? 'active' : 'idle';
          return (
            <span key={i}
              className={`h-2 rounded-[2px] transition-colors duration-300 ${
                state === 'done' ? 'bg-lime-400/80' :
                state === 'active' ? 'bg-orange-400 heavy-shard-pulse' : 'bg-white/10'
              }`}
              style={state === 'active' ? { animationDelay: `${(i % 12) * 0.07}s` } : undefined}
            />
          );
        })}
      </div>
    </motion.div>
  );
}
